import React from "react";
import SelectOrderStrategy from "./SelectOrderStrategy";
import {OrderContractDefineMethodStrategies} from "../../../../app/order/GetStrategies";

const OrderContractDefineMethodStrategy = React.forwardRef(({onChange, ...props}, ref) => (
    <SelectOrderStrategy onChange={onChange} strategies={OrderContractDefineMethodStrategies} {...props} ref={ref}/>
));

export default OrderContractDefineMethodStrategy;